import { UserRole } from '@uplift/types';

import { makeTrackingFunction } from '../use-freshpaint';

export const enum VideoEvent {
  startSession = 'clicked_start_session',
  joinSession = 'clicked_join_session',
  leaveSession = 'clicked_leave_session',
  closeSession = 'clicked_close_session',
  rejoinSession = 'clicked_rejoin_session'
}

type StartSessionClick = {
  eventName: VideoEvent.startSession;
  payload: {
    userType: UserRole;
  };
};

export const trackStartSessionClick =
  makeTrackingFunction<StartSessionClick>(VideoEvent.startSession);

type JoinSessionClick = {
  eventName: VideoEvent.joinSession;
  payload: {
    userType: UserRole;
  };
};

export const trackJoinSessionClick =
  makeTrackingFunction<JoinSessionClick>(VideoEvent.joinSession);

type LeaveSessionClick = {
  eventName: VideoEvent.leaveSession;
  payload: {
    userType: UserRole;
  };
};

export const trackLeaveSessionClick =
  makeTrackingFunction<LeaveSessionClick>(VideoEvent.leaveSession);

type CloseSessionClick = {
  eventName: VideoEvent.closeSession;
  payload: {
    userType: UserRole;
  };
};

export const trackCloseSessionClick =
  makeTrackingFunction<CloseSessionClick>(VideoEvent.closeSession);

type RejoinSessionClick = {
  eventName: VideoEvent.rejoinSession;
  payload: {
    userType: UserRole;
  };
};

export const trackRejoinSessionClick =
  makeTrackingFunction<RejoinSessionClick>(VideoEvent.rejoinSession);
